import { SystemStatusBadge } from '@tempo-io/sui-badge';
import type { Severity } from '@/common/constants/status/severity';

interface StatusBadgeProps {
  variant: Severity;
  label: string;
  count?: number;
  className?: string;
}

export const StatusBadge = ({ variant, label, count, className }: StatusBadgeProps) => {
  return (
    <SystemStatusBadge variant={variant} className={className}>
      <span className="truncate min-w-0">{label}</span>
      {count !== undefined && <span className="font-semibold">{count}</span>}
    </SystemStatusBadge>
  );
};
